import React, { useState } from "react";

import { TextField, IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import "./CommonTextField.scss";

export const CommonTextField = ({
  id,
  className,
  placeholder,
  values,
  errors,
  touched,
  setFieldValue,
  disabled,
  onChangeFormat = (value: any) => value,
  type,
  ...props
}: any) => {
  //State
  const [showPassword, setShowPassword] = useState(false);

  //Options
  const isValidationFailed = errors && touched && errors[id] && touched[id];
  const label = !!props.label || props.label === "" ? props.label : placeholder;
  const computedType = type === "password" && showPassword ? "text" : type;
  const endAdornment = type === "password" ?
    <InputAdornment position="end">
      <IconButton
        className="default"
        aria-label="toggle password visibility"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
    : null;

  return (
    <TextField
      {...props}
      type={computedType}
      disabled={disabled}
      className={"common-text-field " + className}
      name={id}
      value={values[id]}
      onChange={(e: any) => {
        setFieldValue(id, onChangeFormat(e.target.value));
      }}
      variant="outlined"
      required={!disabled}
      label={label}
      placeholder={placeholder}
      error={isValidationFailed}
      helperText={isValidationFailed ? errors[id] : ""}
      InputProps={{
        endAdornment
      }}
    />
  );
};
